import styled from 'styled-components/macro';

export const InputStyled = styled.input`
  display: none;

  &:checked + label {
    background-color: ${({ theme }) => theme.colors.primary.variant1};
  }

  &:checked + label::after {
    left: calc(100% - 2px);
    transform: translateX(-100%);
  }
`;

export const LabelStyled = styled.label`
  position: relative;
  width: 40px;
  height: 20px;
  background-color: ${({ theme }) => theme.colors.primary.variant7};
  border-radius: ${({ theme }) => theme.radius.xl};
  transition: all 0.2s;
  cursor: pointer;

  &::after {
    content: '';
    position: absolute;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: white;
    top: 2px;
    left: 2px;
    transition: all 0.2s;
  }

  &:active:after {
    width: 18px;
  }
`;
